import React, { useEffect } from 'react';
import {
  Badge,
  Box,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography
} from '@material-ui/core';
import { PeopleAlt } from '@material-ui/icons';
import { UserService } from '../../../../hooks';
import { UserViewModel } from '../../../../models/user';
import { notifications } from '../../../../utils';
import { useTranslation } from 'react-i18next';

interface IProps {
  userIds: string[];
}

const EmailPreview = (props: IProps) => {
  const { t } = useTranslation();

  const [open, setOpen] = React.useState<boolean>(false);
  const [users, setUsers] = React.useState<UserViewModel[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const userRepo = new UserService();

  const { userIds } = props;

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  useEffect(() => {
    if (open) {
      setIsLoading(true);
      userRepo
        .getFarmUsers(1, 1000)
        .then((r) => {
          const foundUsers = r.data.filter((u) => userIds.includes(u.id));
          setUsers(() => foundUsers);
        })
        .catch((e) => notifications.error(e.toString()))
        .finally(() => setIsLoading(false));
    }
  }, [open]);

  return (
    <>
      <IconButton
        disabled={userIds.length <= 0}
        color="primary"
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <Badge badgeContent={userIds.length > 0 ? userIds.length : undefined}>
          <PeopleAlt />
        </Badge>
      </IconButton>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition style={{ zIndex: 1 }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper elevation={8}>
              <ClickAwayListener onClickAway={handleClose}>
                <Box minWidth={200}>
                  {isLoading ? (
                    <Box display="flex" alignItems="center" justifyContent="center" width={200} height={100}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                      <MenuItem>{t('f-email-receivers')}:</MenuItem>
                      <Divider />
                      {users.map((u, i) => (
                        <span key={i}>
                          <MenuItem>
                            <Box>
                              <Typography color="secondary">{t(`f-${u.role}`)}</Typography>
                              <Typography color="primary">{u.name}</Typography>
                              <Typography variant="body2">{u.email}</Typography>
                            </Box>
                          </MenuItem>
                          {i !== users.length - 1 && <Divider />}
                        </span>
                      ))}
                    </MenuList>
                  )}
                </Box>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default EmailPreview;
